import * as React from "react";

const ArrowUpSVG = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40">
        <path
            fill="#171718"
            d="m30 24.112-1.775 1.775L20 17.662l-8.225 8.225L10 24.113l10-10z"
        ></path>
    </svg>
);

export default ArrowUpSVG;
